module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("A Mindful Afflatus")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch002#about-the-book"
    }
  }, [_vm._v("About the Book")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch003#dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch004#copyright-information"
    }
  }, [_vm._v("Copyright Information")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch005#acknowledgement"
    }
  }, [_vm._v("Acknowledgement")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch006#based-on-a-true-event"
    }
  }, [_vm._v("Based on a True Event")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch007#prologue"
    }
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch008#friday-june-13th",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Friday, June 13th")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch008#a-plan-is-hatched",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Plan Is Hatched")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch009#saturday-june-14th",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Saturday, June 14th")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch009#hits-of-the-80s",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hits of the ’80s")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch009#smack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SMACK!")])])])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch010#sunday-june-15th",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sunday, June 15th")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch010#late-night-dessert",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Late-Night Dessert")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch011#monday-june-16th",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Monday, June 16th")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch011#sofa-not-so-good",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sofa Not So Good")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch012#tuesday-june-17th",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tuesday, June 17th")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch012#atmospheric-pressure",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Atmospheric Pressure")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch013#wednesday-june-18th",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wednesday, June 18th")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch013#in-hot-water",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In Hot Water")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch014#thursday-june-19th",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thursday, June 19th")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch014#doesnt-sound-good",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Doesn’t Sound Good")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch015#friday-june-20th",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Friday, June 20th")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch015#food-for-thought",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Food for Thought")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch016#saturday-june-21st",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Saturday, June 21st")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch016#all-happening-above",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("All Happening Above")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch017#sunday-june-22nd",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sunday, June 22nd")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch017#lazy-sunday-afternoon",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lazy Sunday Afternoon")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch018#monday-june-23rd",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Monday, June 23rd")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch018#heavy-stuff",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Heavy Stuff")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch018#thud",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THUD!")])])])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch019#tuesday-june-24th",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tuesday, June 24th")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch019#second-thoughts",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Second Thoughts")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch020#wednesday-june-25th",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wednesday, June 25th")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch020#going-around-in-circles",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Going Around in Circles")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch021#thursday-june-26th",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thursday, June 26th")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch021#not-jockular",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Not Jock’ular")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch022#friday-june-27th",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Friday, June 27th")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch022#dust-you-wait-and-see",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dust You Wait and See")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch023#saturday-june-28th",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Saturday, June 28th")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch023#let-the-spirit-flow-free",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Let the Spirit Flow Free")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch024#sunday-june-29th",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sunday, June 29th")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch024#lets-clear-the-air",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Let’s Clear the Air")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch025#monday-june-30th",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Monday, June 30th")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch025#going-going-gone",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Going, Going, Gone?")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-46"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch026#addendum",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Addendum")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-47"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch027#epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6eb74dd3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/nav.vue
// module id = 60
// module chunks = 0